import { render } from "./StyledFromTo.vue?vue&type=template&id=5fc58acb&scoped=true"
import script from "./StyledFromTo.vue?vue&type=script&lang=js"
export * from "./StyledFromTo.vue?vue&type=script&lang=js"

import "./StyledFromTo.vue?vue&type=style&index=0&id=5fc58acb&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc58acb"]])

export default __exports__